import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

export default function Mask(props) {
  const { className, inverted, active } = props;
  const cls = cx("mask", className, { active, inverted });
  return (
    <div className={cls} onClick={props.onClick}>
      {props.children}
    </div>
  );
}

const { string, bool, any, func } = PropTypes;
Mask.propTypes = {
  className: string,
  children: any,
  inverted: bool,
  active: bool,
  onClick: func,
};
Mask.defaultProps = {
  className: "",
  children: null,
  inverted: false,
  active: false,
  onClick: () => null,
};

require("./index.less");
require("./index.less");